import { FC, useEffect } from 'react'
import { CustomSelectFieldGroup } from '@/componentsV2/molecules/CustomSelectFieldGroup'
import { useStores } from '@/utils'
import { observer } from 'mobx-react'
import { SubsidyPurposeBase } from '@/types'

type Props = {
  placeholder: string
  selectedSubsidyPurposeIds: string[]
  setFieldValue: (subsidyPurposeIds: string[]) => void
}

export const SubsidyPurposeIdMultipleSelectField: FC<Props> = observer(
  ({ placeholder, selectedSubsidyPurposeIds, setFieldValue }) => {
    const { viewer, subsidies } = useStores()

    const onSelect = (id: string): void => {
      const isSelected = selectedSubsidyPurposeIds.includes(id)
      if (isSelected) {
        return
      }

      setFieldValue(selectedSubsidyPurposeIds.concat(id))
    }

    const onUnselect = (id: string): void => {
      const isSelected = selectedSubsidyPurposeIds.includes(id)
      if (!isSelected) {
        return
      }

      setFieldValue(selectedSubsidyPurposeIds.filter((selectedId) => selectedId !== id))
    }

    const onUnselectAll = (): void => {
      setFieldValue([])
    }

    const fetchSubsidyPurposes = async () => {
      await subsidies.fetchSubsidyPurposes()
    }

    const convertToItems = (subsidyPurpose: SubsidyPurposeBase): { id: string; name: string } => {
      return {
        id: subsidyPurpose.id,
        name: subsidyPurpose.name,
      }
    }

    const allItems = subsidies.subsidyPurposes?.map(convertToItems)

    const selectedItems = allItems?.filter((item) => selectedSubsidyPurposeIds.includes(item.id))

    const selectableItems = allItems?.map((item) => ({
      instance: item,
      isSelected: selectedSubsidyPurposeIds.includes(item.id),
    }))

    useEffect(() => {
      if (!viewer.isInitialized) {
        return
      }

      if (subsidies?.subsidyPurposes?.length === 0) {
        fetchSubsidyPurposes()
      }
    }, [viewer.isInitialized])

    return (
      <CustomSelectFieldGroup
        placeholder={placeholder}
        onSelect={onSelect}
        onUnselect={onUnselect}
        selectedItems={selectedItems}
        selectableItems={selectableItems}
        onUnselectAll={onUnselectAll}
      />
    )
  }
)
